import { GetCargoItem } from '~hooks/queries/cargo/use-get-cargo'
import { CargoStatus } from '~pages/pages-behind-login/chartering/cargo-list-page/content/select-n-autocomplete-options'
import { mockPreFixture } from './pre-fixture/mock-pre-fixture'

export const fixedCargoMock: GetCargoItem = {
  _id: '2',
  tradingType: 'SPOT',
  privateAndConfidential: false,
  dateQuoted: '2025-05-14',
  status: CargoStatus.Fixed,
  quantityType: 'MT',
  periodTcOutType: 'Months',
  rateHireType: 'WS',
  pool: ['MR'],
  tradingWorldArea: ['Trading worldwide'],
  pic: 'John Doe',
  laycanFrom: '2025-04-24',
  laycanTo: '202525-04-24',
  cargoGrade: ['DPP', 'Dty Cond - DPP'],
  quantity: 30000,
  charterer: 'TBN',
  createdBy: 'John Doe',
  createdAt: '2025-04-25T10:55:27.767Z',
}

export const subsCargoMock: GetCargoItem = {
  _id: '2',
  tradingType: 'SPOT',
  privateAndConfidential: false,
  dateQuoted: '2025-05-14',
  status: CargoStatus.OnSubs,
  quantityType: 'MT',
  periodTcOutType: 'Months',
  rateHireType: 'WS',
  pool: ['MR'],
  tradingWorldArea: ['Trading worldwide'],
  pic: 'John Doe',
  laycanFrom: '2025-04-23',
  laycanTo: '2025-04-24',
  cargoGrade: ['DPP', 'Dty Cond - DPP'],
  quantity: 30000,
  charterer: 'TBN',
  broker: 'Broker Management',
  createdBy: 'John Doe',
  createdAt: '2025-04-25T10:55:27.767Z',
  subsDueTime: '2025-07-12T12:00',
  commercialOperator: 'Tanker Management',
  loadPort: ['ALIAGA', 'AASIAAT'],
  dischargePort: ['COPENHAGEN', 'MALMO'],
  rates: [
    { port: 'COPENHAGEN', rate: 1 },
    { port: 'MALMO', rate: 2 },
    { port: 'For all ports', rate: undefined },
  ],
  hasAdditionalDischargePorts: true,
}

export const openCargoMock: GetCargoItem = {
  _id: '1',
  tradingType: 'SPOT',
  privateAndConfidential: false,
  dateQuoted: '2025-05-14',
  status: CargoStatus.Open,
  quantityType: 'MT',
  periodTcOutType: 'Months',
  rateHireType: 'WS',
  pool: ['MR'],
  tradingWorldArea: ['Trading worldwide'],
  pic: 'johndoe@example.com',
  laycanFrom: 'TBN',
  cargoGrade: ['DPP'],
  quantity: 1,
  charterer: mockPreFixture.name,
  createdBy: 'johndoe@example.com',
  createdAt: '2025-04-28T11:42:43.630Z',
  history: [
    {
      tradingType: 'SPOT',
      privateAndConfidential: false,
      dateQuoted: '2025-05-14',
      status: CargoStatus.Open,
      quantityType: 'MT',
      periodTcOutType: 'Months',
      rateHireType: 'WS',
      pool: ['MR'],
      tradingWorldArea: ['Trading worldwide'],
      pic: 'johndoe@example.com',
      laycanFrom: '2011-11-10',
      laycanTo: '2011-11-10',
      cargoGrade: ['DPP'],
      quantity: 1,
      charterer: 'TBN',
      createdBy: 'johndoe@example.com',
      createdAt: '2025-04-28T11:42:43.630Z',
    },
  ],
  preFixtures: [
    {
      preFixtureId: mockPreFixture._id,
      classification: 'charterer',
      name: 'Royal Dutch Shell',
      type: 'pre-fixture',
    },
  ],
}

export const cargoParserMock = [
  {
    cargoGrade: ['CPP'],
    charterer: 'VITOL',
    quantity: 35000,
    loadPort: ['SOHAR'],
    dischargePort: ['SAFR'],
    laycanFrom: '15-07-2026',
    laycanTo: '16-07-2026',
    demurrage: 32000,
    status: 'On Subs',
    comments: '3:12:24 PM August Ostenfeldt subs wei chi w205 - 32k dem',
    vessel: 'wei chi',
  },
]
